<template>
  <div>
    <dialog-loading loadingText="Carregando..." v-if="loading.truck"></dialog-loading>
    <v-dialog v-model="dialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <dialog-loading loadingText="Salvando..." v-if="saving"></dialog-loading>
      <v-card>
        <v-toolbar dark color="blue-grey">
          <v-btn icon dark @click.native="$router.push({name: 'IndexTrucks'})">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalhes do Veículo</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-expansion-panels :readonly="editing" multiple flat active-class="elevation-4" v-if="!loading.truck" popout v-model="panel">
              
              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header class="d-flex">
                  <div class="red--text font-weight-bold">
                    Informações Gerais
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex mb-2 justify-end">
                    <f-btn edit small v-if="!editing" @click="startEditing('info')"></f-btn>
                    <f-btn cancel small v-if="editing && edit.info" @click="cancelEditing('info')"></f-btn>
                    <f-btn save small v-if="editing && edit.info" @click="updateItem('info')"></f-btn>
                  </div>
                  <InfoForm ref="info_form" :readonly="!edit.info" :vehicle="truck"></InfoForm>
                </v-expansion-panel-content>
              </v-expansion-panel>
              
              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header>
                  <div class="red--text font-weight-bold">
                    Placa, Chassi e Tipo
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex mb-2 justify-end">
                    <f-btn edit small v-if="!editing" @click="startEditing('plate')"></f-btn>
                    <f-btn cancel small v-if="editing && edit.plate" @click="cancelEditing('plate')"></f-btn>
                    <f-btn save small v-if="editing && edit.plate" @click="updateItem('plate')"></f-btn>
                  </div>
                  <PlateForm ref="plate_form" :readonly="!edit.plate" :vehicle="truck" :this_plate_count="plate_count"></PlateForm>
                </v-expansion-panel-content>
              </v-expansion-panel>
  
              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header>
                  <div class="red--text font-weight-bold">
                    Informações de Carga Veículo
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex mb-2 justify-end">
                    <f-btn edit small v-if="!editing" @click="startEditing('props')"></f-btn>
                    <f-btn cancel small v-if="editing && edit.props" @click="cancelEditing('props')"></f-btn>
                    <f-btn save small v-if="editing && edit.props" @click="updateItem('props')"></f-btn>
                  </div>
                  <PropsForm ref="props_form" :readonly="!edit.props" :vehicle="truck"></PropsForm>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
                <v-expansion-panel-header>
                  <div class="red--text font-weight-bold">
                    Módulos do Veículos
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <EditSolutions :model="{text:'veículo', API:'Truck', METHOD:'update'}" @update="handleUpdate" :model_modality_ids="truck?.modality_ids"/>
                </v-expansion-panel-content>
              </v-expansion-panel>

            </v-expansion-panels>
  
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'EditTruck',
  components:{
    PlateForm: () => import("@/_backoffice/_registrations/components/trucks/forms/PlateForm.vue"),
    PropsForm: () => import("@/_backoffice/_registrations/components/trucks/forms/PropsForm.vue"),
    InfoForm: () => import("@/_backoffice/_registrations/components/trucks/forms/InfoForm.vue"),
    EditSolutions: () => import("@/_backoffice/_registrations/components/shared/EditSolutions.vue"),
  },
  data() {
    return {
      dialog: true,
      panel: [0,1],
      saving:false,

      plate_count: 1,

      truck: null,
      backup_truck: {},

      edit:{
        info: false,
        plate: false,
        props: false,
      },
      loading:{
        truck: true,
      },
    }
  },
  methods: {
    getData(){
      this.getTruck()
    },
    handleUpdate(){
      this.getData()
    },
    updateItem(item){
      if(this.$refs[`${item}_form`].validate()){
        this.swallConfirmation({
          title: 'Deseja atualizar informações do veículo?',
          icon: 'question',
        }).then( confirmed =>{
          if (confirmed ) {
            this.saving = true
            Api.Truck.update(this.truck).then(() => {
              this.addNotification({type: 'success',  msg: `Veículo atualizado.`})
            }).catch((err) => {
              this.addNotification({type: 'error',  msg: err})
            }).finally(() => {
              this.saving = false
              this.cancelAllEdits()
            })
          }
        })
      }else{
        this.addNotification({type: 'error',  msg: `Preencha todos os campos.`})
      }
    },
    startEditing(item){
      this.backup_truck = {...this.truck}
      this.edit[item] = true
    },
    cancelEditing(item){
      this.truck = {...this.backup_truck}
      this.edit[item] = false
    },
    cancelAllEdits(){
      this.edit.info = false
      this.edit.plate = false
      this.edit.props = false
    },
    getTruck(){
      let id = this.$route.params.id
      this.loading.truck = true
      Api.Truck.show(id).then(r => r.data).then(data =>{
        this.truck = {...data}
        this.setPlateCount()
      }).finally(()=>{
        this.loading.truck = false
      })
    },
    setPlateCount(){
      if(this.truck?.cargo_plate_1?.length > 0){
        this.plate_count = this.plate_count + 1
      }
      if(this.truck?.cargo_plate_2?.length > 0){
        this.plate_count = this.plate_count + 1
      }
    },
    setEditableVehicle(){
      this.backup_truck = {...this.truck}
    },
    clearEditableVehicle(){
      this.backup_truck = {}
    },
  },
  computed: {
    editing(){
      return this.edit.info || this.edit.plate || this.edit.props
    },
    isMobile() {
      if (document.body.clientWidth < 700)
        return true
      else
        return false
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
  },
}
</script>

<style scoped>
h3 {
  -webkit-text-fill-color: red !important;
}

.bcom-red:hover {
  -webkit-text-fill-color: red !important;
}

.bcom-green:hover {
  -webkit-text-fill-color: limegreen !important;
}

.bcom-yellow:hover {
  /* -webkit-text-fill-color: #FFC107 !important; amber darken-1 */
  -webkit-text-fill-color: #673AB7 !important;
}

h4 {
  -webkit-text-fill-color: red !important;
}
</style>
